export const returnCardDate = (inputDateString) => {
  const inputDate = new Date(inputDateString);

  const day = inputDate.getDate().toString().padStart(2, "0");
  const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
  const year = inputDate.getFullYear();

  const outputDateString = `${day}/${month}/${year}`;
  return outputDateString;
};

export const returnSearchArrOfCollection = (SelectedCollectionType = []) => {
  return SelectedCollectionType.map((ele) => ele.value).filter(
    (ele) => ele !== ""
  );
};

export const getPercentage = (originalAmount, discountPercentage) => {
  let Amount = (originalAmount * discountPercentage) / 100;
  return Math.round(Amount);
};

export const FinialAmount = (Amount, productdetails) => {
  let Sum = Amount;
  Sum = Sum + getPercentage(Sum, productdetails?.GSTIN || 0);
  return Math.round(Sum);
};

export const CustomizedFinialAmount = (Amount, productdetails) => {
  let Sum = Amount;
  Sum = Sum + productdetails?.installnationCharge;
  Sum = Sum + productdetails?.Wastage;
  Sum = Sum + getPercentage(Sum, productdetails?.GSTIN ?? 0);
  return Math.round(Sum);
};

export function calculateFinalAmountWithGST(
  totalPrice,
  width,
  height,
  gstRate
) {
  // Step 1: Calculate initial price per unit
  const baseUnitPrice = Number(
    width && height
      ? totalPrice / (width * height)
      : width
      ? totalPrice / width
      : height
      ? totalPrice / height
      : 0
  );

  // Step 2: Add GST
  const priceWithGST = (baseUnitPrice * (1 + gstRate / 100)).toFixed(0);

  // const priceWithGST = baseUnitPrice + (baseUnitPrice * (gstRate || 0)) / 100;

  // Step 3: Multiply by area (or dimension)
  let multiplier = 1;
  if (width > 0) multiplier *= width;
  if (height > 0) multiplier *= height;

  const finalAmount = priceWithGST * multiplier;

  // Step 4: Return final amount
  return { priceWithGST, finalAmount };
}

export const FinialAmountWithAllAmount = (Amount, productdetails) => {
  let Sum = Amount;
  const Wastage_Amount = getPercentage(Sum, productdetails?._Amount ?? 0);
  Sum = Sum + Wastage_Amount;
  Sum = Sum + (productdetails?.InstallmentAmount ?? 0);
  const GST_Amount = getPercentage(Sum, productdetails?.GSTIN ?? 0);
  Sum = Sum + GST_Amount;
  return Math.round(Sum);
};

export const formatAmount = (amount) => {
  let isAmount = isNaN(amount) ? 0 : amount;
  const MyAmount = Math.abs(isAmount);
  const myAmount = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  }).format(MyAmount);

  return myAmount;
};

export function numberToWords(number) {
  const units = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  function convert(num) {
    if (num < 10) return units[num];
    if (num < 20) return teens[num - 10];
    if (num < 100)
      return (
        tens[Math.floor(num / 10)] +
        (num % 10 !== 0 ? " " + units[num % 10] : "")
      );
    if (num < 1000)
      return (
        units[Math.floor(num / 100)] +
        " Hundred" +
        (num % 100 !== 0 ? " " + convert(num % 100) : "")
      );
    if (num < 100000)
      return (
        convert(Math.floor(num / 1000)) +
        " Thousand" +
        (num % 1000 !== 0 ? " " + convert(num % 1000) : "")
      );
    if (num < 10000000)
      return (
        convert(Math.floor(num / 100000)) +
        " Lakh" +
        (num % 100000 !== 0 ? " " + convert(num % 100000) : "")
      );
    return "Number too large";
  }

  if (number === 0) return "Zero Rupees Only";

  const [integerPart, decimalPart] = number.toString().split(".");

  const integerWords = convert(parseInt(integerPart)) + " Rupees";
  const decimalWords = decimalPart
    ? " and " + convert(parseInt(decimalPart)) + " Paise"
    : "";

  return integerWords + decimalWords + " Only";
}

export function generateInvoiceNumber(invoiceNumber) {
  const prefix = "RPL";

  // Get current financial year
  const today = new Date();
  const currentYear = today.getFullYear();
  const fyStart = today.getMonth() >= 3 ? currentYear : currentYear - 1;
  const fy = `${fyStart.toString().slice(-2)}-${(fyStart + 1)
    .toString()
    .slice(-2)}`;

  // Increment and format serial number
  const newSerial = String(invoiceNumber).padStart(4, "0");

  return `${prefix}/${fy}/${newSerial}`;
}
